import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { projectConfig } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserPromptService {

  public apiURL: string = projectConfig.apiURL;

  constructor(private http: HttpClient) { }

  addToFeedback(request:any) {
    const url = this.apiURL + 'prompt_manager/prompt_feedback';
    return this.http.put<any>(url,request);
  }

  approvePrompt(request:any) {
    const url = this.apiURL + 'prompt_approval/approve_or_reject_prompt';
    return this.http.put<any>(url,request);
  }

  private dataSource = new BehaviorSubject<boolean>(true);
  currentData = this.dataSource.asObservable();
  changeData(data: boolean) {
    this.dataSource.next(data);
  }

}